export default {
    name: 'monitoringFilter',
    namespaced: true,
    state: {
        filtro: {
            show: false,
            status: true,
            integration_type: null,
            vns_filter: '',
            company_filter: null,
            status_filter: ''
        }
    },
    getters: {
        all (state) {
            return state.filtro
        },
        getSpecific (state, key) {
            return state.filtro[key]
        },
    },
    mutations: {
        setAll (state, obj) {
            state.filtro = obj
        },
        setSpecific (state, obj) {
            state.filtro = {...state.filtro, ...obj}
        },
    },
    actions: {
        setFiltro ({ commit, state }, obj) {
            commit('setAll', obj)
        },
        setSpecific ({ commit, state }, obj) {
            commit('setSpecific', obj)
        },
        reset ({ commit, state }) {
            commit('setSpecific', {
                show: false,
                status: true,
                integration_type: null,
                vns_filter: '',
                company_filter: null
            })
        },
    }
}
